import React, { Component } from "react";
import Table from "../common/Table";
import { ToastContainer, toast } from "react-toastify";

export default class Imports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accounts: [],
      searchConditions: {},
      lastPage: 1,
      currentPage: 1,
      from: "",
      to: "",
      total: "",
      file: null,
    };

    this.handleDelete = this.handleDelete.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handleRedirect = this.handleRedirect.bind(this);
    this.onChangeUpload = this.onChangeUpload.bind(this);
    this.handleImportAccounts = this.handleImportAccounts.bind(this);
  }

  /**
   * Init data and form client or list accounts
   */
  componentWillMount() {
    const keySearch_str = this.props.location.search.substring(1);
    let keySearch_arr = { page: 1 };
    if (keySearch_str) {
      keySearch_arr = JSON.parse(
        '{"' +
          decodeURI(keySearch_str.replace(/&/g, '","').replace(/=/g, '":"')) +
          '"}'
      );
    }

    //always get list data
    axios
      .post("/api/tracking-import-errors/1", keySearch_arr)
      .then((response) => {
        this.setState({
          accounts: response.data.data,
          lastPage: response.data.last_page,
          currentPage: response.data.current_page,
          searchConditions: keySearch_arr,
          from: response.data.from,
          to: response.data.to,
          total: response.data.total,
        });
        this.props.history.push({
          search: keySearch_str,
        });
      });
  }

  /**
   * Get search data
   */
  handleSearch(key) {
    //add search params to search conditions
    let newSearchConditions = this.state.searchConditions;
    newSearchConditions.sort_column = key.sort_column;
    newSearchConditions.sort_type = key.sort_type;
    this.setState({
      searchConditions: newSearchConditions,
    });
    axios
      .post("/api/tracking-import-errors/1", newSearchConditions)
      .then((response) => {
        this.setState({
          accounts: response.data.data,
          lastPage: response.data.last_page,
          currentPage: response.data.current_page,
          from: response.data.from,
          to: response.data.to,
          total: response.data.total,
        });
        this.props.history.push({
          search: $.param(newSearchConditions),
        });
      });
  }

  /**
   * Sort data
   */
  handleSort(key) {
    //add sort params to search conditions
    let newSearchConditions = this.state.searchConditions;
    newSearchConditions.sort_column = key.sort_column;
    newSearchConditions.sort_type = key.sort_type;
    this.setState({
      searchConditions: newSearchConditions,
    });
    axios
      .post("/api/tracking-import-errors/1", newSearchConditions)
      .then((response) => {
        this.setState({
          accounts: response.data.data,
          lastPage: response.data.last_page,
          currentPage: response.data.current_page,
          from: response.data.from,
          to: response.data.to,
          total: response.data.total,
        });
        this.props.history.push({
          search: $.param(newSearchConditions),
        });
      });
  }

  /**
   * Handle redirect
   */
  handleRedirect(e) {
    e.preventDefault();
    this.props.history.push(e.currentTarget.getAttribute("href"));
  }

  /**
   * Handle redirect
   */
  handleDelete(item) {
    if (window.confirm("ID" + item.id + "を削除してもよろしいですか？")) {
      axios
        .post("/api/tracking-import-errors/delete/" + item.id)
        .then((response) => {
          if (response.data.success) {
            this.setState({
              accounts: this.state.accounts.filter((m) => m.id != item.id),
            });
          }
        });
    }
  }

  onChangeUpload(e) {
    let fileName = "";
    if (e.target.files.length > 0) {
      fileName = e.target.files[0].name;
      this.setState({ file: e.target.files[0] });
    } else {
      this.setState({ file: null });
    }
    $("#selected_filename").text(fileName);
  }

  /**
   * Handle upload csv
   */
  handleImportAccounts() {
    this.setState({ importDisable: true })
    console.log(this.state.importDisable);
    if (this.state.importDisable) {
      return;
    }
    const formData = new FormData();
    formData.append("file", this.state.file);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    if (this.state.file != null) {
      $(".cover-loading").show();
      axios
        .post("/api/accounts/import", formData, config)
        .then((response) => {
          if (response.data.success) {
            $(".cover-loading").hide();
            toast.success(
              <div>
                CSVインポートを行っています。
                <br />
                {response.data.message}
              </div>
            );
          } else {
            $(".cover-loading").hide();
            toast.error(
              <div>
                正しくないCSVファイルです。
                <br />
                {response.data.errors}
              </div>
            );
          }
          this.setState({ importDisable: false })
        })
        .catch((error) => {
          $(".cover-loading").hide();
          Object.keys(error.response.data.errors).map((key, i) => {
            if ($.isArray(error.response.data.errors[key])) {
              error.response.data.errors[key].map((child, i) => {
                toast.error(child);
              });
            } else {
              toast.error(error.response.data.errors[key]);
            }
          });
          this.setState({ importDisable: false })
        });
      this.setState({ file: null });
      $("#selected_filename").text("選択されていません");
    }
  }

  render() {
    const columns = [
      { name: "id", title: "ID", isSort: 1, type: "text" },
      { name: "firstname", title: "苗字", isSort: 1, type: "text" },
      { name: "lastname", title: "名前", isSort: 1, type: "text" },
      {
        name: "hiragana_firstname",
        title: "苗字カナ",
        isSort: 1,
        type: "text",
      },
      { name: "hiragana_lastname", title: "名前カナ", isSort: 1, type: "text" },
      { name: "gender", title: "性別", isSort: 1, type: "text" },
      { name: "birthday", title: "生年月日", isSort: 1, type: "text" },
      { name: "zip_no", title: "郵便番号", isSort: 1, type: "text" },
      { name: "pref", title: "都道府県", isSort: 1, type: "text" },
      { name: "city", title: "市区", isSort: 1, type: "text" },
      { name: "address", title: "住所1", isSort: 1, type: "text" },
      { name: "address2", title: "住所2", isSort: 1, type: "text" },
      { name: "tel", title: "電話番号", isSort: 0, type: "text" },
      {
        name: "email",
        title: "メールアドレス",
        isSort: 1,
        type: "text",
      },
      {
        name: "sharejob_created_at",
        title: "シェアジョブ登録日",
        isSort: 1,
        type: "text",
      },
      { name: "remark", title: "メモ", isSort: 1, type: "text" },
      { name: "staff_evaluation_avg", title: "ワーカー評価", isSort: 1, type: "text" },
      { name: "created_at", title: "インポート日時", isSort: 1, type: "text" },
      {
        name: "error_reason",
        title: "エラー理由",
        isSort: 0,
        type: "text",
      },
      {
        name: "",
        title: "操作",
        isSort: 0,
        type: "action",
        elements: ["delete"],
        delete_except_ids: [],
      },
    ];
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a onClick={this.handleRedirect} href="/home">
                    ダッシュボード
                  </a>
                </li>
                <li className="breadcrumb-item">
                  <a onClick={this.handleRedirect} href="/accounts">
                    登録者一覧
                  </a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  CSVインポート
                </li>
              </ol>
            </nav>
          </div>
        </div>

        <main id="main">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="card">
                      <div className="card-header">
                        <h4 className="mt-2 mb-0 page-title">CSVインポート</h4>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-sm">
                            <div className="form-group">
                              <input
                                type="file"
                                accept=".csv"
                                id="fileimport"
                                className="d-none"
                                onClick={(e) => (e.target.value = "")}
                                onChange={this.onChangeUpload}
                              />
                              <button
                                onClick={() => {
                                  $("#fileimport").click();
                                }}
                                className="btn btn-sm btn-secondary"
                              >
                                ファイルを選択
                              </button>
                              <span id="selected_filename" className="ml-2">
                                選択されていません
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm">
                            <button
                              onClick={this.handleImportAccounts}
                              className="btn btn-lg btn-primary"
                            >
                              インポート
                            </button>
                          </div>
                          <div className="cover-loading block-hidden">
                            処理中...
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Table
                  onSearch={this.handleSearch}
                  header={columns}
                  data={this.state.accounts}
                  onSort={this.handleSort}
                  from={this.state.from}
                  to={this.state.to}
                  total={this.state.total}
                  myPagination={1}
                  onDelete={this.handleDelete}
                  lastPage={this.state.lastPage}
                  currentPage={this.state.currentPage}
                  searchConditions={this.state.searchConditions}
                />
              </div>
            </div>
          </div>
        </main>
        <ToastContainer />
      </React.Fragment>
    );
  }
}
